import $ from 'jquery';

$('a[href="#cookies"]').on('click', (e) => {
    e.preventDefault();
    window.openAxeptioCookies();
});
